import React, {ChangeEvent, FC, HTMLAttributes, useEffect, useState} from 'react';
import css from './Switcher.module.scss';
import classNames from 'classnames/bind';
import {CheckboxOptionProps} from "../CheckboxGroup/interfaces/CheckboxOptionProps";

const cx = classNames.bind(css);

interface SwitcherProps extends HTMLAttributes<HTMLInputElement> {
    values: CheckboxOptionProps[],
}

const Switcher: FC<SwitcherProps> = ({values, className}) => {
    const [currentValues, setCurrentValues] = useState<CheckboxOptionProps[]>([]);

    useEffect(() => {
        setCurrentValues(values);
    }, [values])

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const {checked, id} = e.target;
        const currentTarget = values.find(v => v.value === id);
        currentTarget!.isChecked = checked;
        setCurrentValues(prevState => prevState.map(p => {
            if (p.id === currentTarget!.id) {
                p.isChecked = currentTarget!.isChecked;
            }
            return p
        }))
    };


    return (
        <form className={cx(css.wrapper, className)}>
            {currentValues.map((value) => (
                <div key={value.id} className={css.wrapper__item}>
                    <label className={css.switcher}>
                        {value.value}
                        <input
                            className={css.switcher__input}
                            id={value.value}
                            type="checkbox"
                            checked={value.isChecked}
                            onChange={onChange}
                        />
                    </label>
                    {value.hint && (<p className={css.hint}>{value.hint}</p>)}
                </div>

            ))}
        </form>
    );
};

export default Switcher;